<template xmlns="http://www.w3.org/1999/html">
  <hm-content title="">
    <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="130px"
    >
      <div>
        <el-form-item label="奖励模式" prop="rewardMode">
          <el-radio-group
              v-model="ruleForm.rewardMode"
              @change="rewardSwitch"
          >
            <el-radio label="related"
            >关联奖励</el-radio
            >
            <el-radio label="stand"
            >独立奖励</el-radio
            >
          </el-radio-group>
          <div class="flex" v-if="ruleForm.rewardMode==='related'">
            <el-switch class="reward"
                       v-model="ruleForm.relRewardState"
                       active-color="#2d8"
                       inactive-color="#ff4949"
                       active-text="开启"
                       inactive-text="关闭"
                       active-value="yes"
                       inactive-value="no"
            ></el-switch>
            <el-checkbox-group v-model="ruleForm.relRewardTypes  ">
              <el-checkbox
                  @change="rewardSwitch"
                  v-for="(v, i) in relationBox"
                  :key="i"
                  :label="v.name"
              >{{ v.value }}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="flex" v-if="ruleForm.rewardMode==='related'">
            <el-form-item prop="rewardIntergalValue" :rules="rules.all">
              积分
              <el-input
                  size="small"
                  clearable
                  class="mr20 ml10 ipt"
                  maxlength="18"
                  style="width: 200px"
                  @input="filterGt0OrFixed0('rewardIntergalValue')"
                  v-model.trim="ruleForm.rewardIntergalValue"
                  placeholder="请输入积分"
              ></el-input>
              优惠券
              <el-select
                  size="small"
                  clearable
                  style="width: 200px"
                  placeholder="请选择奖励券包"
                  filterable
                  v-model="ruleForm.rewardCouponSendValue"
              >
                <el-option
                    :label="v.name"
                    :value="v.couponSendId"
                    v-for="(v, i) in couponList"
                    :key="i"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="基本信息" prop="rewardState">
          <el-switch
              :disabled="basicSwitch"
              v-model="ruleForm.basicRewardConfig.rewardState"
              active-color="#2d8"
              inactive-color="#ff4949"
              active-text="开启"
              inactive-text="关闭"
              active-value="yes"
              inactive-value="no"
          ></el-switch>
        </el-form-item>

        <div style="margin-left: 75px;">
          <el-form-item label="关联奖励" prop="rewardRelType">
            <div class="flex" style="margin-bottom: 20px">
              <el-select
                  size="small"
                  placeholder="选择关联奖励"
                  v-model="ruleForm.basicRewardConfig.rewardRelType"
              >
                <el-option label="完善指定信息" value="appoint"></el-option>
                <el-option label="完善所有未填信息" value="all"></el-option>
              </el-select>
            </div>
          </el-form-item>
        </div>

        <div style="margin-left: 75px;">
          <el-form-item>
            <div
                class="flex"
                style="margin-bottom: 20px"
                v-for="(v, index) in ruleForm.basicRewardConfig.regConfigVoList"
                :key="index"
                v-if="ruleForm.basicRewardConfig.rewardRelType === 'appoint'"
            >

              <el-form-item
                  :prop="`basicRewardConfig.regConfigVoList.${index}.checked`"
                  :rules="rules.checked"
              >
                <el-checkbox v-model="v.checked" class="mr10" style="width: 100px">
                  {{ v.fillingKeyName }}
                </el-checkbox>
              </el-form-item>
              <el-form-item
                  :prop="`basicRewardConfig.regConfigVoList.${index}.fillingKeyName`"
                  :rules="rules.fillingKeyName"
              >
                积分
                <el-input
                    size="small"
                    clearable
                    class="mr20 ipt"
                    maxlength="18"
                    style="width: 200px"
                    @input="filterGt0OrListFixed0(index, 'rewardIntergalValue')"
                    v-model.trim="v.rewardIntergalValue"
                    placeholder="请输入积分"
                ></el-input>

                优惠券
                <el-select
                    size="small"
                    clearable
                    placeholder="请选择奖励券包"
                    filterable
                    v-model="v.rewardCouponSendValue"
                >
                  <el-option
                      :label="v.name"
                      :value="v.couponSendId"
                      v-for="(v, i) in couponList"
                      :key="i"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div v-if="ruleForm.basicRewardConfig.rewardRelType === 'all'">
              <el-form-item prop="rewardRelType" :rules="rules.all">
                积分
                <el-input
                    size="small"
                    clearable
                    class="mr20 ml10 ipt"
                    maxlength="18"
                    style="width: 200px"
                    @input="filterGt0OrFixed0('rewardIntergalValue')"
                    v-model.trim="ruleForm.basicRewardConfig.rewardIntergalValue"
                    placeholder="请输入积分"
                ></el-input>
                优惠券
                <el-select
                    size="small"
                    clearable
                    style="width: 200px"
                    placeholder="请选择奖励券包"
                    filterable
                    v-model="ruleForm.basicRewardConfig.rewardCouponSendValue"
                >
                  <el-option
                      :label="v.name"
                      :value="v.couponSendId"
                      v-for="(v, i) in couponList"
                      :key="i"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-form-item>
        </div>
      </div>

      <div>
        <el-form-item label="添加企业微信" prop="companyWechat">
          <el-switch
              :disabled="qywxSwitch"
              v-model="ruleForm.qywxRewardConfig.rewardState"
              active-color="#2d8"
              inactive-color="#ff4949"
              active-text="开启"
              inactive-text="关闭"
              active-value="yes"
              inactive-value="no"
          ></el-switch>
        </el-form-item>
        <div>
          <el-form-item>
            <el-form-item label="企业微信码">
              <div class="flex">
                <div class="import-btn open-file">
                  <div
                      class="upload-wrapper flex flex-column item-center flex-center"
                      @click="uploadImg('qywx')"
                      v-if="!ruleForm.qywxRewardConfig.additionalValue"
                  >
                    <div class="add-wrapper">
                      <span class="hmicon icon-hao pointer"></span>
                    </div>
                    <span>上传企业微信码</span>
                  </div>
                  <div class="img-wrapper" v-if="ruleForm.qywxRewardConfig.additionalValue">
                    <div class="close-wrapper" @click="ruleForm.qywxRewardConfig.additionalValue = ''">
                      <span class="hmicon icon-jujue"></span>
                    </div>
                    <img :src="ruleForm.qywxRewardConfig.additionalValue" alt="" @click="uploadImg('qywx')" />
                  </div>
                </div>
                <div class="opreat-wrapper flex item-center flex-center" v-if="ruleForm.qywxRewardConfig.additionalValue">
                  <el-button type="text" @click="removePic('qywx')">删除图片</el-button>
                </div>
                <div class="form-tip opreat-wrapper flex item-center flex-center">水印尺寸建议750x750，请上传png格式</div>
              </div>
            </el-form-item>
          </el-form-item>
        </div>

        <div style="margin-left: 75px;">
          <el-form-item>
            <el-form-item prop="rewardRelType" :rules="rules.all">
              积分
              <el-input
                  size="small"
                  clearable
                  class="mr20 ml10 ipt"
                  maxlength="18"
                  style="width: 200px"
                  @input="filterGt0OrFixed0('rewardIntergalValue')"
                  v-model.trim="ruleForm.qywxRewardConfig.rewardIntergalValue"
                  placeholder="请输入积分"
              ></el-input>
              优惠券
              <el-select
                  size="small"
                  clearable
                  style="width: 200px"
                  placeholder="请选择奖励券包"
                  filterable
                  v-model="ruleForm.qywxRewardConfig.rewardCouponSendValue"
              >
                <el-option
                    :label="v.name"
                    :value="v.couponSendId"
                    v-for="(v, i) in couponList"
                    :key="i"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
        </div>
      </div>

      <div>
        <el-form-item label="关注公众号" prop="gzh">
          <el-switch
              :disabled="gzhSwitch"
              v-model="ruleForm.gzhRewardConfig.rewardState"
              active-color="#2d8"
              inactive-color="#ff4949"
              active-text="开启"
              inactive-text="关闭"
              active-value="yes"
              inactive-value="no"
          ></el-switch>
        </el-form-item>

        <div>
          <el-form-item>
            <el-form-item prop="gzhName">
              公众号昵称
              <el-input
                  :disabled="true"
                  size="small"
                  clearable
                  class="mr20 ml10 ipt"
                  maxlength="18"
                  style="width: 200px"
                  v-model.trim="gzhName"
              ></el-input>
            </el-form-item>
          </el-form-item>
        </div>

        <div style="margin-left: 75px;">
          <el-form-item>
            <el-form-item prop="rewardRelType" :rules="rules.all">
              积分
              <el-input
                  size="small"
                  clearable
                  class="mr20 ml10 ipt"
                  maxlength="18"
                  style="width: 200px"
                  @input="filterGt0OrFixed0('rewardIntergalValue')"
                  v-model.trim="ruleForm.gzhRewardConfig.rewardIntergalValue"
                  placeholder="请输入积分"
              ></el-input>
              优惠券
              <el-select
                  size="small"
                  clearable
                  style="width: 200px"
                  placeholder="请选择奖励券包"
                  filterable
                  v-model="ruleForm.gzhRewardConfig.rewardCouponSendValue"
              >
                <el-option
                    :label="v.name"
                    :value="v.couponSendId"
                    v-for="(v, i) in couponList"
                    :key="i"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
        </div>
      </div>

      <el-form-item label="添加底部广告">
        <div class="flex">
          <div class="import-btn open-file">
            <div
                class="upload-wrapper flex flex-column item-center flex-center"
                @click="uploadImg('ad')"
                v-if="!ruleForm.adImg"
            >
              <div class="add-wrapper">
                <span class="hmicon icon-hao pointer"></span>
              </div>
              <span>上传图片</span>
            </div>
            <div class="img-wrapper" v-if="ruleForm.adImg">
              <div class="close-wrapper" @click="ruleForm.adImg = ''">
                <span class="hmicon icon-jujue"></span>
              </div>
              <img :src="ruleForm.adImg" alt="" @click="uploadImg('ad')" />
            </div>
          </div>
          <div class="opreat-wrapper flex item-center flex-center" v-if="ruleForm.adImg">
            <el-button type="text" @click="removePic('ad')">删除图片</el-button>
          </div>
          <div class="form-tip opreat-wrapper flex item-center flex-center">水印尺寸建议750x750，请上传png格式</div>
        </div>
        <div style="margin-left: -75px;">
          <el-form-item label="跳转链接" prop="linkUrl">
            <el-radio-group
                v-model="ruleForm.linkType"
                @change="openGoodsSelectSingle"
            >
              <el-radio label="page"
              >页面</el-radio
              >
              <el-radio label="goods"
              >商品</el-radio
              >
            </el-radio-group>
            <div class="flex item-center" v-if="ruleForm.linkType === 'page'">
              <span class="mr10">链接</span>
              <el-select
                  size="small"
                  clearable
                  placeholder="选择页面"
                  v-model="ruleForm.linkUrl"
                  filterable
                  @change="selectGroup"
                  v-if="!ruleForm.groupName"
              >
                <el-option
                    v-for="(item, i) in microShopRouteList"
                    :key="i"
                    :label="item.hrefName"
                    :value="item.hrefAddress"
                ></el-option>
              </el-select>
              <div v-if="ruleForm.groupName">
                <el-tag closable @close="handleClose" type="success">
                  {{ ruleForm.groupName }}
                </el-tag>
              </div>
            </div>
            <div
                class="flex item-center"
                v-if="ruleForm.linkType === 'goods' && ruleForm.spuName"
            >
              <span class="mr10">商品</span>
              <el-tag closable @close="handleCloseSingle" type="success">{{
                  ruleForm.spuName
                }}</el-tag>
            </div>
            <div
                v-if="ruleForm.linkType === 'coupon' && ruleForm.couponList.length"
            >
              <div class="table">
                <el-table border stripe size="mini" :data="ruleForm.couponList">
                  <!-- <el-table-column
                    header-align="center"
                    align="center"
                    type="index"
                    label="序号"
                    width="50"
                    index
                  ></el-table-column> -->
                  <el-table-column
                      header-align="center"
                      align="center"
                      prop="name"
                      label="券名"
                  ></el-table-column>
                  <el-table-column
                      header-align="center"
                      align="center"
                      prop="levelMin"
                      label="使用门槛"
                  ></el-table-column>
                  <el-table-column
                      header-align="center"
                      align="center"
                      prop="account"
                      label="减免金额"
                  ></el-table-column>
                  <el-table-column
                      header-align="center"
                      align="center"
                      prop="isPlusFormat"
                      label="会员类型"
                  ></el-table-column>
                  <el-table-column
                      label="操作"
                      header-align="center"
                      align="center"
                  >
                    <template slot-scope="scope">
                      <div class="flex flex-center">
                        <el-tooltip class="item" content="删除" placement="top">
                          <div
                              class="pointer mr10"
                              @click="removeCoupon(scope.$index)"
                          >
                            <span class="hmicon icon-shanchu primary"></span>
                          </div>
                        </el-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="flex item-center" v-if="ruleForm.linkType === 'miniProgram'">
              <span style="width: 45px">appid</span>
              <el-input
                  placeholder="请输入appid"
                  v-model="ruleForm.appId"
                  size="small"
                  clearable>
              </el-input>
            </div>
            <div class="flex item-center" v-if="ruleForm.linkType === 'miniProgram'">
              <span style="width: 45px">链接</span>
              <el-input
                  placeholder="请输入链接"
                  v-model="ruleForm.linkUrl"
                  size="small"
                  clearable>
              </el-input>
            </div>
          </el-form-item>
        </div>

      </el-form-item>

      <el-form-item label="完善信息提示说明" prop="rewardRemark">
        <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 5 }"
            placeholder="请输入15字以内文字说明，在个人中心进行提示。"
            v-model="ruleForm.rewardRemark"
            maxlength="15"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <hm-filter-micro-shop-goods
        type="microShop"
        :visible="dialogVisible"
        radio
        @setLink="setLink"
        @close="dialogVisible = false"
    ></hm-filter-micro-shop-goods>
    <hm-filter-group-goods
        @saveGroupGoods="saveGroupGoods"
        @close="groupGoodsVisible = false"
        :visible="groupGoodsVisible"
    ></hm-filter-group-goods>
    <hm-upload
        :hmUploadVisible="show"
        fileDir="decoration"
        @cancleUpload="show = false"
        @hmUploadSuccess="hmUploadSuccess"
    ></hm-upload>
    <hm-upload
        :hmUploadVisible="adPic"
        fileDir="decoration"
        @cancleUpload="adPic = false"
        @hmUploadSuccess="adUploadSuccess"
    ></hm-upload>
    <div class="btn-wrapper flex flex-center">
      <el-button @click="submitRuleForm('ruleForm')" size="small" type="primary"
      >保存</el-button
      >
      <el-button @click="back" size="small">返回</el-button>
    </div>
  </hm-content>
</template>

<script>
import HmFilterMicroShopGoods from "@/components/HmFilterMicroShopGoods";
import {mapGetters} from "vuex";
import HmFilterGroupGoods from "@/components/HmFilterGroupGoods";
import HmUpload from "@/components/HmUpload";

export default {
  components: {
    HmFilterMicroShopGoods,
    HmFilterGroupGoods,
    HmUpload
  },
  data() {
    const patternAll = (rule, val, callback) => {
      if (val === "all") {
        if (
            !this.ruleForm.rewardIntergalValue &&
            !this.ruleForm.rewardCouponSendValue
        ) {
          return callback(new Error("请填写"));
        }
      }

      callback();
    };
    const patternList = (rule, val, callback) => {
      let row = this.ruleForm.basicRewardConfig.regConfigVoList.find(
          v => v.fillingKeyName === val
      );

      if (
          row.checked &&
          !row.rewardIntergalValue &&
          !row.rewardCouponSendValue
      ) {
        return callback(new Error("请填写"));
      }

      callback();
    };
    return {
      ruleForm: {
        basicRewardConfig:{
          regConfigVoList: [],
          rewardRelType: "",
          rewardState: "no",
          rewardIntergalValue: "",
          rewardRemark: "",
          rewardCouponSendValue: "",
        },
        companyWechat: "no",
        gzh: "no",
        companyWechatPic: "",
        spuName: "",
        linkUrl: "",
        groupName: "",
        groupId: "",
        linkType: "",
        adImg: "",
        relation: "",
        rewardMode: "",
        relRewardTypes: [],
        relRewardState: "no",
        rewardRelType:"",
        rewardRemark: "",
        gzhRewardConfig:{
          additionalValue: "",
          rewardCouponSendValue: "",
          rewardIntergalValue: 0,
          rewardState: "",
        },
        qywxRewardConfig:{
          additionalValue: "",
          rewardCouponSendValue: "",
          rewardIntergalValue: 0,
          rewardState: "",
        },
        rewardState:"",
        rewardIntergalValue: "",
        rewardCouponSendValue: ""
      },
      show: false,
      adPic: false,
      rules: {
        fillingKeyName: [{ validator: patternList }],
        all: [{ validator: patternAll }],
        // rewardState: {
        //   required: true,
        //   trrger: "blur"
        // },
        // rewardRelType: [
        //   {
        //     required: true,
        //     message: "选择关联奖励"
        //   }
        // ],
        // companyWechat: {
        //   required: true,
        //   trrger: "blur"
        // },
        // gzh: {
        //   required: true,
        //   trrger: "blur"
        // }
      },
      couponList: [],
      type: "",
      gzhName: "",
      gzhId:"",
      groupGoodsVisible: false,
      dialogVisible: false,
      relationBox: [
        {
          name: "basic",
          value: "基础信息"
        },
        {
          name: "qywx",
          value: "添加企业微信"
        },
        {
          name: "gzh",
          value: "关注公众号"
        }
      ],
      basicSwitch: true,
      qywxSwitch: true,
      gzhSwitch: true,
    };
  },
  computed: {
    ...mapGetters(["microShopRouteList"]),
  },
  watch: {},
  created() {
    this.$store.dispatch("queryMicroShopList", {
      pageType: "page"
    });
    this.queryCouponList();
    this.queryMpMember();
  },
  mounted() {},
  methods: {
    rewardSwitch() {
      console.log(this.ruleForm.rewardMode)
      console.log(this.ruleForm.relRewardTypes)
      if (!this.ruleForm.relRewardTypes) {
        this.ruleForm.relRewardTypes = ["basic","qywx","gzh"];
      }
      if (this.ruleForm.rewardMode === 'related') {
        if (this.ruleForm.relRewardTypes.indexOf("gzh") != -1) {
          this.gzhSwitch = true;
          this.ruleForm.gzhRewardConfig.rewardState = "yes";
        } else {
          this.basicSwitch = true;
        }
        if (this.ruleForm.relRewardTypes.indexOf("qywx") != -1) {
          this.qywxSwitch = true;
          this.ruleForm.qywxRewardConfig.rewardState = "yes";
        } else {
          this.qywxSwitch = true;
        }
        if (this.ruleForm.relRewardTypes.indexOf("basic") != -1) {
          this.basicSwitch = true;
          this.ruleForm.basicRewardConfig.rewardState = "yes";
        } else {
          this.basicSwitch = true;
        }
      } else {
        this.basicSwitch = false;
        this.qywxSwitch = false;
        this.gzhSwitch = false;
      }
      console.log(this.gzhSwitch);
      console.log(this.qywxSwitch);
      console.log(this.basicSwitch);

    },
    hmUploadSuccess(url) {
      this.ruleForm.qywxRewardConfig.additionalValue = url;
      this.show = false;
    },
    adUploadSuccess(url) {
      this.ruleForm.adImg = url;
      this.adPic = false;
    },
    uploadImg(type) {
      if (type === 'qywx') {
        this.show = !this.show;
      } else if (type === 'ad') {
        this.adPic =!this.adPic;
      }
      console.log(this.show);
      console.log(this.ruleForm.qywxRewardConfig.additionalValue)
    },
    removePic(type) {
      console.log(type)
      if (type === 'qywx') {
        this.ruleForm.qywxRewardConfig.additionalValue = "";
      } else if (type === 'ad') {
        this.ruleForm.adImg = ""
      }
    },
    selectGroup(e) {
      if (e === "groupGoods") {
        this.groupGoodsVisible = true;
      }
    },
    saveGroupGoods(row) {
      this.groupGoodsVisible = false;
      this.ruleForm.linkUrl = `/pages/product/list?groupId=${row.groupId}`;
      this.ruleForm.groupName = row.groupName;
      console.log("设置连接", this.ruleForm.groupName)
    },
    setLink(row) {
      this.ruleForm.linkUrl = `/pages/product/product?wxshopSpuId=${row.wxshopSpuId}`;
      this.ruleForm.spuName = row.wxshopSpuName;
      this.dialogVisible = false;
      console.log("设置商品", this.ruleForm.spuName)
    },
    openGoodsSelectSingle() {
      if (this.ruleForm.linkType === "goods") {
        this.dialogVisible = true;
        this.isRadio = true;
        // 为-1表示设置单个
        this.currentLinkIndex = -1;
      }
      this.ruleForm.spuName = "";
      this.ruleForm.linkUrl = "";
      this.ruleForm.groupName = "";
      this.ruleForm.groupId = "";
    },
    handleClose() {
      this.ruleForm.groupName = "";
      this.ruleForm.linkUrl = "";
    },
    handleCloseSingle() {
      this.ruleForm.spuName = "";
      this.ruleForm.linkUrl = "";
      this.ruleForm.linkType = "page";
    },
    async queryMpMember() {
      const { code, result } = await this.$store.dispatch(
          "mp_member"
      );
      if (code === "0") {
        this.gzhName = result.nickName;
        this.gzhId = result.authorizerAppid;
      }
    },
    async queryCouponList() {
      const { code, result } = await this.$store.dispatch(
          "findCouponSendByEvent",
          {
            event: "activity"
          }
      );
      if (code === "0") {
        this.couponList = result;
        this.queryDetails();
      }
    },
    async queryMemberRegConfigList() {
      const { code, result } = await this.$store.dispatch(
          "queryMemberRegConfigList"
      );
      if (code === "0") {
        result.forEach(v => {
          // v.checked = false;
          v.checked = v.writeRewardState === "yes" ? true : false;
          if (
              this.couponList.findIndex(
                  o => o.couponSendId === v.rewardCouponSendValue
              ) < 0
          ) {
            v.rewardCouponSendValue = "";
          }
          // v.rewardCouponSendValue = !this.couponList.length
          //   ? ""
          //   : v.rewardCouponSendValue;
        });

        console.log(this.ruleForm.relRewardTypes);
        this.ruleForm.basicRewardConfig.regConfigVoList = result;
        if (result.rewardMode === 'stand') {
          this.ruleForm.basicRewardConfig.rewardState = result.basicRewardConfig.rewardState;
          this.ruleForm.gzhRewardConfig.rewardState = result.gzhRewardConfig.rewardState;
          this.ruleForm.qywxRewardConfig.rewardState = result.qywxRewardConfig.rewardState;
        }
        // this.ruleForm.regConfigVoList.forEach(v => {
        //   v.checked = v.writeRewardState === "yes" ? true : false;
        //   v.rewardCouponSendValue = !this.couponList.length
        //     ? ""
        //     : v.rewardCouponSendValue;
        // });
        this.$forceUpdate();
      }
    },
    async queryDetails() {
      const { code, result } = await this.$store.dispatch(
          "queryRegRewardConfig"
      );
      if (code === "0") {
        if (result) {
          this.type = "edit";
          if (result.basicRewardConfig.rewardRelType === "appoint") {
            result.basicRewardConfig.regConfigVoList.forEach(v => {
              v.checked = v.writeRewardState === "yes" ? true : false;
            });
          }
          if (result.basicRewardConfig.regConfigVoList && result.basicRewardConfig.regConfigVoList.length) {
            result.basicRewardConfig.regConfigVoList.forEach(v => {
              if (
                  this.couponList.findIndex(
                      o => o.couponSendId === v.rewardCouponSendValue
                  ) < 0
              ) {
                v.rewardCouponSendValue = "";
              }
            });
          }
          for (let key in result) {

            this.ruleForm[key] = result[key];
          }
          console.log(":::", this.ruleForm.spuName);
          console.log(":::", this.ruleForm.linkUrl);


          if (this.ruleForm.basicRewardConfig.rewardRelType === "appoint") {
            this.ruleForm.regConfigVoList.forEach(v => {
              v.checked = v.writeRewardState === "yes" ? true : false;
            });
          } else {
            this.queryMemberRegConfigList();
            if (
                !this.couponList.findIndex(
                    o => o.couponSendId === this.ruleForm.basicRewardConfig.rewardCouponSendValue
                ) >= 0
            ) {
              this.ruleForm.basicRewardConfig.rewardCouponSendValue = "";
            }
          }
        } else {
          this.type = "add";
          this.queryMemberRegConfigList();
        }
        this.rewardSwitch();
      }
    },
    filterGt0OrListFixed0(index, prop) {
      this.ruleForm.basicRewardConfig.regConfigVoList[index][
          prop
          ] = this.ruleForm.basicRewardConfig.regConfigVoList[index][prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm.basicRewardConfig.regConfigVoList[index][
          prop
          ] = this.ruleForm.basicRewardConfig.regConfigVoList[index][prop].replace(/[^\d]/g, "");
      this.ruleForm.basicRewardConfig.regConfigVoList[index][
          prop
          ] = this.ruleForm.basicRewardConfig.regConfigVoList[index][prop]
          .replace(".", "")
          .replace("-", "")
          .replace(",", "");
    },
    filterGt0OrFixed0(prop) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d]/g, "");
      // this.ruleForm[prop] = this.ruleForm[prop]
      //     .replace(".", "")
      //     .replace("-", "")
      //     .replace(",", "");
    },
    submitRuleForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const params = JSON.parse(JSON.stringify(this.ruleForm));
          if (params.basicRewardConfig.rewardRelType === "appoint") {
            let regConfigVoList = [];
            params.basicRewardConfig.regConfigVoList.forEach(v => {
              if (v.checked) {
                regConfigVoList.push(v);
              }
            });
            params.regConfigVoList = regConfigVoList;
          }
          let name =
              this.type === "add" ? "saveRegRewardConfig" : "editRegRewardConfig";
          this.$store.dispatch(name, params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功！",
                type: "success"
              });
              this.queryDetails();
            }
          });
        }
      });
    },
    back() {
      this.$router.back(-1);
    }
  }
};
</script>
<style lang='scss' scoped>
.title {
  font-weight: bold;
  font-size: 16px;
}
.reward {
  margin-top: 10px;
  margin-right: 40px;
}
.add-wrapper {
  margin: 0 auto;
}
.open-file {
  position: relative;
  overflow: hidden;
}
.open-file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.import-btn {
  position: relative;
  border: 1px dashed #ddd;
  text-align: center;
  width: 102px;
  height: 102px;
  box-sizing: border-box;
  text-align: center;
  margin-right: 10px;
  cursor: pointer;
  .upload-wrapper {
    height: 100%;
  }
  .close-wrapper {
    position: absolute;
    top: -20px;
    right: -10px;
    z-index: 100;
    .hmicon {
      font-size: 20px;
    }
  }
  .img-wrapper {
    img {
      width: 100%;
    }
  }
  .add-wrapper {
    margin: 0 auto;
  }
}
</style>
